
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trophies",
      function () {
        return require("private-next-pages/trophies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trophies"])
      });
    }
  